import { j as e } from "./jsx-runtime-944c88e2.js";
import { Box as o, Text as r, Center as n, Link as x, Button as g } from "@chakra-ui/react";
import "react";
const y = ({
  title: c,
  requestIDText: s,
  confirmationText: h,
  descHeader1: j,
  desc1: d,
  descHeader2: m,
  desc2: f,
  linkFmipLBL: p,
  linkClosePageLBL: u,
  btnRateServiceLBL: b,
  onClickRateServiceBtn: i,
  onClickFmipLink: t,
  onClickClose: l,
  children: D,
  ...E
}) => /* @__PURE__ */ e.jsxs(o, { ...E, alignItems: "center", p: 4, children: [
  /* @__PURE__ */ e.jsx(r, { fontSize: "3xl", mt: 3, children: c }),
  /* @__PURE__ */ e.jsx(r, { fontWeight: 700, mt: 2, children: s }),
  /* @__PURE__ */ e.jsx(r, { my: 2, children: h }),
  /* @__PURE__ */ e.jsx(r, { fontSize: "2xl", mt: 5, mb: 2, children: j }),
  /* @__PURE__ */ e.jsx(r, { children: d }),
  /* @__PURE__ */ e.jsx(r, { fontSize: "2xl", mt: 5, mb: 2, children: m }),
  /* @__PURE__ */ e.jsx(r, { children: f }),
  /* @__PURE__ */ e.jsx(n, { mt: 5, children: /* @__PURE__ */ e.jsx(x, { onClick: () => t && t(), color: "#1ED760", children: p }) }),
  /* @__PURE__ */ e.jsx(n, { my: 4, children: /* @__PURE__ */ e.jsx(
    g,
    {
      w: "300px",
      bg: "#1ED760",
      color: "white",
      _hover: { bg: "#1ED760", color: "white", outline: "none" },
      onClick: () => i && i(),
      children: b
    }
  ) }),
  /* @__PURE__ */ e.jsx(n, { children: /* @__PURE__ */ e.jsx(o, { children: /* @__PURE__ */ e.jsx(x, { onClick: () => l && l(), color: "#1ED760", children: u }) }) })
] });
export {
  y as SubmitRequest
};
